import React, { useState } from "reactn";
import "./RequestInfo.css";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { ModalTemplate } from "../UI/modalComponents";
import BaseModal from "./baseModal/BaseModal";
import { BLUE_BUTTON, RED_BUTTON } from "./baseModal/colours";
import { STRING_INPUT, TITLE } from "./baseModal/FieldTypes";

/**
 * Modal can be used as an archive/unarchive confirmation modal.
 *
 * @callback onSubmit Function executed upon user confirmation
 * @callback onClose Function executed when modal is closed.
 *
 * @param {Boolean} toArchive true means archival, false means unarchival.
 * @param {Boolean} confirmHeader Optional custom modal header.
 * @param {String | JSX} modalBody Optional custom modal body.
 *
 * @param {Boolean} isPermanent Whether the deletion is permanent. Will show extra text prompt.
 * @param {Boolean} notAllowed If true, there will be no confirmation button.
 * @param {Boolean} cancelApps Determine whether to set all applications in the existing program to 'Inactive'
 */

const LoadingCSVModal = ({
  onSubmit,
  onClose,
}) => {
  
  const confirmationHandler = async e => {
    try {
      e.preventDefault();
      onClose();
      toast.success("Successfully Downloaded");
    } catch (error) {
      console.error('Error in confirmationHandler:', error);
    }
  };

  const getModalFields = () => {
    const titleField = {
      type: TITLE,
      data: {
        name: "Heads up! This file includes more than 500 rows and may take a minute or two to fully download. The download has started—hang tight while it finishes."
      }
    };
    const descriptionField = {
      type: TITLE,
      data: {
        name: "Please check your download folder in a minute."
      }

    }

    const fields = [];

    fields.push(titleField);
    fields.push(descriptionField);
    return fields;
  };

  const getModalButtons = () => {
    const createButton = {
      name: "Okay",
      buttonColour: BLUE_BUTTON,
      textColour: "#fff",
      handleClick: confirmationHandler
    };
    return [createButton];
  };

  //Modal for when deletion is allowed;
  const getModalProps = () => {
    return {
      title: "Confirmation",
      fields: getModalFields(),
      buttons: getModalButtons(),
      height: "65vh",
      midSectionHeight: "52vh",
      handleClose: onClose
    };
  };


  return (
    <>
        <BaseModal {...getModalProps()} />
    </>
  );
};

export default LoadingCSVModal;
